import _ from 'lodash';
import {
    useQuery,
    useMutation,
    useQueryClient
} from 'react-query';


async function updateCompaniesSelectionAsync({companyIds, companySetName, addCompanySetToCompany}) {

    const companies = RivalIQ.state.landscape.get('companies').filter(company => _.includes(companyIds, company.get('id')));
    if (addCompanySetToCompany) {
        return RivalIQ.state.companySets.addCompanySetToCompanies(companySetName, companies);
    } else {
        return RivalIQ.state.companySets.removeCompanySetFromCompanies(companySetName, companies);
    }
}

async function deleteCompanySetAsync({companySetId}) {
    return RivalIQ.state.companySets.deleteCompanySet(companySetId);
}

async function createCompanySetAsync({name}) {

    const landscapeId = RivalIQ.state.view.get('landscapeId');
    const res = await $.ajax({
        url: `/api/landscape/${landscapeId}/companySets`,
        type: 'PUT',
        data: {
            companySetName: name
        }
    });

    RivalIQ.state.companySets.add({
        id: name,
        name: name,
        isUserCompanySet: true,
        companySetId: res.id
    });
}

async function editCompanySetAsync({name, currentName, companySetId}) {
    const landscapeId = RivalIQ.state.view.get('landscapeId');
    const res = await $.post(`/api/landscape/${landscapeId}/companySets/${companySetId}`, {
        name: name
    });

    const companySet = RivalIQ.state.companySets.get(companySetId);
    const oldName = companySet.get('name');
    companySet.set({
        id: res.description,
        name: res.description
    });

    _.each(RivalIQ.state.landscape.get('companies').models, company => {
        const companySetNames = company.get('companySetNames');
        if (_.includes(companySetNames, oldName)) {
            company.set({
                companySetNames: _.union(_.without(companySetNames, oldName), [name])
            });
        }
    });
}

export function useGetCompanySets() {
    return useQuery('companySets', async () => {
        const companySetNameToCompanyIds = RivalIQ.state.landscape.get('companies').reduce((memo, company) => {
            const companyId = company.get('id');
            const companySetNames = company.get('companySetNames');

            _.each(companySetNames, companySetName => {
                memo[companySetName] = _.union(memo[companySetName] || [], [companyId]).sort();
            });

            return memo;
        }, {});

        return RivalIQ.state.companySets.getUserCompanySets().map(companySet => {
            return {
                id: companySet.get('companySetId'),
                name: companySet.get('name'),
                companyIds: companySetNameToCompanyIds[companySet.get('name')] || []
            };
        });
    });
}

export function useDeleteCompanySet() {
    const queryClient = useQueryClient();

    return useMutation(deleteCompanySetAsync, {
        onSettled: (data, variables) => {
            queryClient.invalidateQueries('companySets');
        }
    });
}

export function useUpdateCompanySetCompanies() {
    const queryClient = useQueryClient();

    return useMutation(updateCompaniesSelectionAsync, {
        onSettled: (data, variables) => {
            queryClient.invalidateQueries('companySets');
        }
    });
}

export function useCreateCompanySet() {
    const queryClient = useQueryClient();

    return useMutation(createCompanySetAsync, {
        onSettled: (data, variables) => {
            queryClient.invalidateQueries('companySets');
        }
    });
}

export function useEditCompanySet() {
    const queryClient = useQueryClient();

    return useMutation(editCompanySetAsync, {
        onSettled: (data, variables) => {
            queryClient.invalidateQueries('companySets');
        }
    });
}

export function useGetCompanySetUsageCounts(companySetId) {
    return useQuery(`companySetUsageCounts:${companySetId}`, async () => {
        const landscapeId = RivalIQ.state.view.get('landscapeId');
        const data = await $.getJSON(`/api/landscape/${landscapeId}/companySets/${companySetId}/companySetUsageCounts`);
        return data;
    }, {
        staleTime: Infinity
    });
}
